import { render, staticRenderFns } from "./InputContingentPrice.vue?vue&type=template&id=23f53d98&"
import script from "./InputContingentPrice.vue?vue&type=script&lang=js&"
export * from "./InputContingentPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports